<template>
  <div>
    <div class="row fixHeight p-0 m-0">
      <LiveLocatorMap :left-col-hidden="leftColHidden" :toggle-map="toggleMap" />
    </div>
    <BaseMapStylesDialog />
    <LiveLocatorDataCell :toggle-map="toggleMap" />
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import BaseMapStylesDialog from '.././base_map_dialog/BaseMapStylesDialog.vue';
import LiveLocatorDataCell from "./components/LiveLocatorDataCell.vue";
import LiveLocatorMap from "./components/LiveLocatorMap.vue";
import mapboxgl from "mapbox-gl";
import {throttle} from 'lodash-es';
import {GridRefUtils} from "../../utils/helpers/GridRefPreference";
import {RevenueCatWrapper} from "../../utils/RevenueCatWrapper";
import {HiikerMapStyle} from "../../utils/models/MapStyles";
import store from "./store/store";
import {LayerRegistry} from "../../utils/layer-registry";
import {IndexedDBCache} from "../../utils/crosshair_altitude_service/indexed_db_cache";
import {getElevation} from "../../utils/crosshair_altitude_service/pixel_methods";
import {buildCoordsLabel} from "./liveLocatorMap";
import emitter from "../../utils/bus";

export default defineComponent({
  components: { BaseMapStylesDialog, LiveLocatorMap, LiveLocatorDataCell },
  data() {
    return {
      leftColHidden: false,
    };
  },
  async beforeCreate() {
    this.$store.state.liveLocator.loading = true
    await this.$store.dispatch('mapStyles/initialiseStore');
  },
  async mounted() {
    await this.initialiseMap()
    this.$store.dispatch('liveLocator/getLiveLocatorData')
  },
  methods: {
    toggleMap() {
      this.$data.leftColHidden = !this.$data.leftColHidden;
      window.map.resize();
    },
    async initialiseMap() {
      mapboxgl.accessToken = "pk.eyJ1IjoiaGlpa2VyLW1hcHMiLCJhIjoiY2x0YThyZHppMWhmejJqbzExODBuY3dveiJ9.nBrtnXgbzxpAx_953HCB-w"
      const map = new mapboxgl.Map(this.$store.getters["liveLocator/mapOptions"]);
      const gridRef = GridRefUtils.preference();
      const isProOrProPlus = await RevenueCatWrapper.isProOrProPlus();
      map.setStyle(HiikerMapStyle.getCurrentStyle(isProOrProPlus).styleUrl)
      map.on('style.load', () => {
        console.log("Watching firebase")
        this.$store.dispatch('liveLocator/watchFirebase')
        // A base-map style change wipes all custom sources/layers, so re-add the
        // track line + pulsing dot on every style (re)load. No-ops until the
        // first Firebase snapshot has populated geoJsonFeature.
        this.$store.dispatch('liveLocator/drawLine')
        // Lets the map component pick up the instance for the scale bar.
        emitter.emit('map-loaded')
      });
      const cache = new IndexedDBCache();
      const handleMouseMove = async (e: mapboxgl.MapMouseEvent & Object) => {
        const coords = gridRef.convert(e.lngLat);
        const elevation = await getElevation(e.lngLat, e.target.getZoom(), cache);
        store.commit('liveLocator/setMiniCoordsBar', buildCoordsLabel(coords.toString(), elevation))
      };
      map.on('mousemove', throttle(handleMouseMove, 100));
      window.map = map;
      window.layerRegistry = new LayerRegistry(map);
    },
  },
});
</script>
